module.exports = __webpack_public_path__ + "img/wands_pointing_up.c550766a.jpg";